// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yGts","label":"styles_label__24Luf"};